export namespace RouterAction {
    export class Navigate {
        static readonly type = 'RouterAction.Navigate';

        constructor(public parts: string | any[], public extras: any = {}) {
        }
    }
}
